'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_Lcom_raquo_airstream_split_Splittable__findUpdateByIndex__O__I__O__O($thiz, inputs, index, newItem) {
  var ix = new $j_java$002elang$002e$002dObject.$c_sr_IntRef((-1));
  var f = ((input) => {
    var ev$6 = ((1 + ix.b6) | 0);
    ix.b6 = ev$6;
    return ((ix.b6 === index) ? newItem : input);
  });
  if ((inputs === $j_java$002elang$002e$002dObject.$m_sci_Nil$())) {
    var $x_1 = $j_java$002elang$002e$002dObject.$m_sci_Nil$();
  } else {
    var x0 = inputs.E();
    var h = new $j_java$002elang$002e$002dObject.$c_sci_$colon$colon(f(x0), $j_java$002elang$002e$002dObject.$m_sci_Nil$());
    var t = h;
    var rest = inputs.H();
    while ((rest !== $j_java$002elang$002e$002dObject.$m_sci_Nil$())) {
      var x0$1 = rest.E();
      var nx = new $j_java$002elang$002e$002dObject.$c_sci_$colon$colon(f(x0$1), $j_java$002elang$002e$002dObject.$m_sci_Nil$());
      t.ao = nx;
      t = nx;
      rest = rest.H();
    }
    var $x_1 = h;
  }
  return $x_1;
}
export { $f_Lcom_raquo_airstream_split_Splittable__findUpdateByIndex__O__I__O__O as $f_Lcom_raquo_airstream_split_Splittable__findUpdateByIndex__O__I__O__O };
function $f_Lcom_raquo_airstream_split_Splittable__zipWithIndex__O__O($thiz, inputs) {
  var ix = new $j_java$002elang$002e$002dObject.$c_sr_IntRef((-1));
  var f = ((input) => {
    var ev$7 = ((1 + ix.b6) | 0);
    ix.b6 = ev$7;
    return new $j_java$002elang$002e$002dObject.$c_T2(input, ix.b6);
  });
  if ((inputs === $j_java$002elang$002e$002dObject.$m_sci_Nil$())) {
    var $x_1 = $j_java$002elang$002e$002dObject.$m_sci_Nil$();
  } else {
    var x0 = inputs.E();
    var h = new $j_java$002elang$002e$002dObject.$c_sci_$colon$colon(f(x0), $j_java$002elang$002e$002dObject.$m_sci_Nil$());
    var t = h;
    var rest = inputs.H();
    while ((rest !== $j_java$002elang$002e$002dObject.$m_sci_Nil$())) {
      var x0$1 = rest.E();
      var nx = new $j_java$002elang$002e$002dObject.$c_sci_$colon$colon(f(x0$1), $j_java$002elang$002e$002dObject.$m_sci_Nil$());
      t.ao = nx;
      t = nx;
      rest = rest.H();
    }
    var $x_1 = h;
  }
  return $x_1;
}
export { $f_Lcom_raquo_airstream_split_Splittable__zipWithIndex__O__O as $f_Lcom_raquo_airstream_split_Splittable__zipWithIndex__O__O };
